import React from 'react';
import { motion } from 'framer-motion';
export function Differentiation() {
  return <section className="py-32 relative overflow-hidden" data-id="element-23">
      {/* Background with subtle gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-navy-deep via-[#0A1A2F] to-navy-deep z-0" data-id="element-24" />
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-primary/20 to-transparent" data-id="element-25" />
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-primary/20 to-transparent" data-id="element-26" />

      <div className="max-w-5xl mx-auto px-6 relative z-10 text-center" data-id="element-27">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-5xl lg:text-6xl font-extrabold text-white mb-8 leading-[1.15]" data-id="element-28">
          No Generamos Prospectos. Construimos Sistemas Que los{' '}
          <span className="text-primary" data-id="element-29">Convierten en Clientes.</span>
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-xl md:text-2xl text-muted leading-relaxed max-w-4xl mx-auto" data-id="element-30">
          La mayoría de las agencias te venden más tráfico. CONECKTA se asegura
          de que cada interesado que ya tienes se convierta en un cliente fiel.
        </motion.p>
      </div>
    </section>;
}